// src/Component/QuickServices/geo.js
// (keep it in the SAME folder as LocationPickerModal.jsx, which imports "./geo")
//
// Parses what Google Maps copies when you right-click a point: "28.4595, 77.0266" (lat, lng).
// Also accepts a space separator, an optional "@" prefix, and °/N/E marks.
// Returns { lat, lng } or null if the input is not a coordinate pair.
export function parseLatLng(input) {
  if (!input) return null;

  const s = String(input).trim().replace(/[°NnEe]/g, "").replace(/^@/, "");
  const m = s.match(/^(-?\d{1,3}(?:\.\d+)?)\s*[,\s]\s*(-?\d{1,3}(?:\.\d+)?)$/);
  if (!m) return null;

  let lat = parseFloat(m[1]);
  let lng = parseFloat(m[2]);
  if (Math.abs(lat) > 90 || Math.abs(lng) > 180) return null;

  // Users are in India (lat ~6-38, lng ~68-98). If the order looks swapped
  // (longitude-like value first), correct it. Normal input is never altered.
  const looksSwapped = lat >= 68 && lat <= 98 && lng >= 6 && lng <= 38;
  if (looksSwapped) [lat, lng] = [lng, lat];

  return { lat, lng };
}